export const localStorage = {
    setItem: <Value>(key: string, value: Value) => {
        if (typeof window !== "undefined") {
            window.localStorage.setItem(key, JSON.stringify(value))
        }
    },
    getItem: <Value = string>(key: string, defaultV?: Value): Value | undefined => {
        if (typeof window !== "undefined") {
            const value = window.localStorage.getItem(key)

            if (value !== undefined && value !== "undefined") {
                try {
                    return (value && JSON.parse(value)) as Value
                } catch {
                    return defaultV || (value as Value)
                }
            }
        }
    },
    removeItem: (key: string) => {
        if (typeof window !== "undefined") {
            window.localStorage.removeItem(key)
        }
    },
}

export interface NewsletterObject {
    isSubscribed: boolean
    date: string
}

interface Session {
    accessToken: string
    expires: string
}

export const sessionController = () => {
    return {
        get: async (getSession: () => Promise<Session | null>) => {
            return localStorage.getItem<string>("cognito-auth") || (await getSession().then((res) => res?.accessToken))
        },
        set: (session: Session) => {
            localStorage.setItem<string>("cognito-auth", session.accessToken)
        },
        clear: () => {
            localStorage.removeItem("cognito-auth")
        },
    }
}

export const setTwProfilekey = (key: string) => localStorage.setItem<{ key: string }>("x-tw-profilekey", { key })
export const getTwProfilekey = () => localStorage.getItem<{ key: string }>("x-tw-profilekey", { key: "" })?.key
